import { format, formatDistanceToNow, Locale } from 'date-fns';
import { enCA, frCA } from 'date-fns/locale';

import { currentLocale } from '@/plugins/i18n';

function diffInDays(start: number | string | Date, end: number | string | Date): number {
  const startDate = new Date(start);
  const endDate = new Date(end);
  const diffInMilliseconds = endDate.valueOf() - startDate.valueOf();
  const diffInDays = diffInMilliseconds / (1000 * 60 * 60 * 24);
  return Math.round(diffInDays);
}

function formatDate(date: number): string {
  let dateFormat: string;
  let locale: Locale;
  switch (currentLocale()) {
    case 'en':
      dateFormat = 'yyyy MMMM d';
      locale = enCA;
      break;
    case 'fr':
    default:
      dateFormat = 'd MMMM yyyy';
      locale = frCA;
      break;
  }
  return format(new Date(date * 1000), dateFormat, { locale });
}

function formatDistanceDateToNow(date: Date): string {
  const locale = (() => {
    switch (currentLocale()) {
      case 'en':
        return enCA;
      case 'fr':
      default:
        return frCA;
    }
  })();
  return formatDistanceToNow(date, { locale });
}

function getCurrentYear(): number {
  return new Date().getFullYear();
}

function todayInTimestamp(): number {
  return Math.floor(Date.now() / 1000);
}

export { diffInDays, formatDate, formatDistanceDateToNow, getCurrentYear, todayInTimestamp };
